import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useAuth } from '../contexts/AuthContext'
import '../design/tokens.css'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'
const erroMsg = (e: any, padrao: string) => e?.response?.data?.erro || padrao
const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

// regra da senha nova (a mesma que o servidor confere)
export function erroDaSenha(s: string): string | null {
  if (s.length < 8) return 'A senha deve ter pelo menos 8 caracteres'
  if (s.length > 72) return 'A senha pode ter no máximo 72 caracteres'
  if (!/[A-Za-z]/.test(s) || !/\d/.test(s)) return 'A senha precisa ter letras e números'
  return null
}

type Tela = 'login' | 'esqueci' | 'enviado' | 'redefinir' | 'redefinido'

const CSS = `
.lg-raiz{--lg-vidro:rgba(255,255,255,.66);--lg-vidro-borda:rgba(255,255,255,.7);--lg-sombra:0 1px 2px rgba(10,42,94,.06),0 18px 50px rgba(10,42,94,.14);height:100vh;overflow:auto;display:grid;grid-template-columns:minmax(0,5fr) minmax(0,6fr);font:100%/1.5 system-ui,-apple-system,'Segoe UI','SF Pro Text',Roboto,sans-serif;font-optical-sizing:auto;color:var(--color-foreground);background:var(--color-background)}
:is(.dark) .lg-raiz,.lg-raiz.dark{--lg-vidro:rgba(17,24,39,.62);--lg-vidro-borda:rgba(255,255,255,.14);--lg-sombra:0 1px 2px rgba(0,0,0,.4),0 18px 50px rgba(0,0,0,.45)}
.lg-marca{position:relative;overflow:hidden;background:var(--primitive-color-navy-900);color:#cfdcf5;padding:4rem 3.5rem;display:flex;flex-direction:column;justify-content:center;gap:2.5rem}
.lg-marca::before{content:"";position:absolute;inset:0;background:radial-gradient(34rem 22rem at 0% 0%,rgba(57,135,229,.35),transparent 60%),radial-gradient(28rem 20rem at 100% 100%,rgba(25,158,112,.22),transparent 62%);pointer-events:none}
.lg-marca>*{position:relative}
.lg-display{font-size:clamp(2rem,3.4vw,3.1rem);line-height:1.05;letter-spacing:-.025em;font-weight:700;color:#fff;max-width:14ch;margin:0}
.lg-benef{display:flex;flex-direction:column;gap:.9rem;font-size:.9375rem;letter-spacing:.005em}
.lg-benef span{display:flex;align-items:center;gap:.7rem}
.lg-benef i{width:2rem;height:2rem;border-radius:.6rem;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.16);display:grid;place-items:center;font-style:normal;font-size:1rem}
.lg-form{position:relative;isolation:isolate;display:flex;align-items:center;justify-content:center;padding:2rem 1.25rem}
.lg-form::before{content:"";position:absolute;inset:0;z-index:-1;background:radial-gradient(30rem 20rem at 85% 0%,rgba(11,102,234,.16),transparent 62%),radial-gradient(26rem 18rem at 0% 100%,rgba(25,158,112,.1),transparent 62%)}
.lg-cartao{width:100%;max-width:25rem;border-radius:1.5rem;padding:2rem 1.75rem;background:var(--lg-vidro);backdrop-filter:blur(22px) saturate(180%);-webkit-backdrop-filter:blur(22px) saturate(180%);border:1px solid var(--lg-vidro-borda);border-top-color:rgba(255,255,255,.5);box-shadow:var(--lg-sombra)}
.lg-logo{display:block;margin:0 auto 1.4rem;width:11rem;max-width:62%;height:auto}
.lg-titulo{font-size:1.5rem;line-height:1.15;letter-spacing:-.02em;font-weight:650;color:var(--color-foreground);margin:0}
.lg-sub{font-size:.875rem;color:var(--color-muted-foreground);margin:.3rem 0 0}
.lg-vista{display:flex;flex-direction:column;gap:.95rem;animation:lg-avanca 240ms cubic-bezier(.22,1,.36,1) both}
.lg-vista.volta{animation-name:lg-volta}
@keyframes lg-avanca{from{opacity:0;transform:translateX(14px)}to{opacity:1;transform:none}}
@keyframes lg-volta{from{opacity:0;transform:translateX(-14px)}to{opacity:1;transform:none}}
.lg-campo{width:100%;box-sizing:border-box;height:2.75rem;border-radius:.875rem;border:1px solid var(--color-border-strong);background:var(--color-surface);color:var(--color-foreground);padding:0 .9rem;font:inherit;font-size:1rem;outline:none;transition:border-color 120ms,box-shadow 120ms}
.lg-campo::placeholder{color:var(--color-muted-foreground)}
.lg-campo:focus{border-color:var(--color-primary);box-shadow:var(--primitive-shadow-focus)}
.lg-campo[aria-invalid=true]{border-color:var(--color-danger)}
.lg-rotulo{display:block;font-size:.75rem;letter-spacing:.012em;color:var(--color-muted-foreground);margin:0 0 .3rem}
.lg-dica{font-size:.75rem;margin:.3rem 0 0;color:var(--color-danger)}
.lg-botao{width:100%;height:2.875rem;border:0;border-radius:.875rem;background:var(--color-primary);color:#fff;font:inherit;font-size:.9375rem;font-weight:600;letter-spacing:-.005em;cursor:pointer;transition:transform 100ms ease-out,background-color 100ms ease-out;touch-action:manipulation}
.lg-botao:hover{background:var(--color-primary-hover)}
.lg-botao:active{transform:scale(.97);background:var(--color-primary-active)}
.lg-botao:disabled{opacity:.65;cursor:default;transform:none}
.lg-botao:focus-visible,.lg-link:focus-visible,.lg-olho:focus-visible{outline:3px solid var(--color-ring);outline-offset:2px}
.lg-link{background:none;border:0;color:var(--color-primary);font:inherit;font-size:.8125rem;cursor:pointer;padding:.15rem 0;border-radius:.4rem;transition:opacity 100ms}
.lg-link:active{opacity:.6}
.lg-erro{background:var(--color-danger-bg);border:1px solid var(--color-danger);border-radius:.875rem;padding:.65rem .85rem;font-size:.8125rem;color:var(--color-danger)}
.lg-ok{background:var(--color-success-bg);border:1px solid var(--color-success);border-radius:.875rem;padding:.8rem .9rem;font-size:.8125rem;color:var(--color-success)}
.lg-olho{position:absolute;right:.4rem;top:50%;transform:translateY(-50%);background:none;border:0;cursor:pointer;color:var(--color-muted-foreground);font:inherit;font-size:.8125rem;padding:.4rem .55rem;border-radius:.5rem}
.lg-regras{list-style:none;margin:0;padding:0;display:grid;gap:.25rem;font-size:.75rem;color:var(--color-muted-foreground)}
.lg-regras li{display:flex;align-items:center;gap:.4rem}
.lg-regras li::before{content:"○";font-size:.8rem}
.lg-regras li.ok{color:var(--color-success)}.lg-regras li.ok::before{content:"●"}
.lg-rodape{text-align:center;font-size:.75rem;letter-spacing:.012em;color:var(--color-muted-foreground);margin:1.6rem 0 0}
@media (max-width:900px){.lg-raiz{grid-template-columns:1fr}.lg-marca{display:none}}
@media (prefers-reduced-motion:reduce){.lg-vista,.lg-vista.volta{animation:lg-fade 150ms ease both}@keyframes lg-fade{from{opacity:0}to{opacity:1}}.lg-botao,.lg-campo{transition:none}.lg-botao:active{transform:none}}
@media (prefers-reduced-transparency:reduce){.lg-cartao{background:var(--color-surface);backdrop-filter:none;-webkit-backdrop-filter:none}}
@media (prefers-contrast:more){.lg-cartao{background:var(--color-surface);backdrop-filter:none;-webkit-backdrop-filter:none;border:2px solid var(--color-foreground)}.lg-campo{border-width:2px}}
`

function CampoSenha({ id, rotulo, valor, aoMudar, autoComplete }: { id: string; rotulo: string; valor: string; aoMudar: (v: string) => void; autoComplete: string }) {
  const [ver, setVer] = useState(false)
  return (
    <div>
      <label className="lg-rotulo" htmlFor={id}>{rotulo}</label>
      <div style={{ position: 'relative' }}>
        <input id={id} className="lg-campo" type={ver ? 'text' : 'password'} value={valor} autoComplete={autoComplete} required style={{ paddingRight: 72 }}
          onChange={(e) => aoMudar(e.target.value)} />
        <button type="button" className="lg-olho" aria-label={ver ? 'Esconder senha' : 'Mostrar senha'} onClick={() => setVer(!ver)}>{ver ? 'Esconder' : 'Mostrar'}</button>
      </div>
    </div>
  )
}

// regras da senha nova, mostradas enquanto digita (retorno na hora, sem esperar o envio)
function Regras({ senha }: { senha: string }) {
  const itens: [boolean, string][] = [[senha.length >= 8, 'Pelo menos 8 caracteres'], [/[A-Za-z]/.test(senha), 'Letras'], [/\d/.test(senha), 'Números']]
  return <ul className="lg-regras" aria-label="Regras da senha">{itens.map(([ok, t]) => <li key={t} className={ok ? 'ok' : ''}>{t}</li>)}</ul>
}

const prefereEscuro = () => { try { return window.matchMedia('(prefers-color-scheme: dark)').matches } catch { return false } }

// "telaInicial" so serve para testes e para a pre-visualizacao do visual: no uso normal a tela comeca no login (ou na redefinicao, se veio pelo link)
export default function Login({ aoConcluir, telaInicial }: { aoConcluir?: () => void; telaInicial?: Tela } = {}) {
  const { login } = useAuth()
  const tokenUrl = (() => { try { return new URLSearchParams(window.location.search).get('redefinir') } catch { return null } })()
  const [tela, setTelaBruta] = useState<Tela>(telaInicial || (tokenUrl ? 'redefinir' : 'login'))
  const [volta, setVolta] = useState(false)
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')
  const [dicaEmail, setDicaEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [canal, setCanal] = useState<'email' | 'whatsapp'>('email')
  const [mensagem, setMensagem] = useState('')
  const [linkValido, setLinkValido] = useState<null | boolean>(telaInicial === 'redefinir' ? true : null)
  const [novaSenha, setNovaSenha] = useState('')
  const [confirma, setConfirma] = useState('')
  const escuro = prefereEscuro()

  // a tela nova entra pelo lado de onde o usuario "foi": avanca vem da direita, voltar vem da esquerda
  const irPara = (nova: Tela, voltando = false) => { setVolta(voltando); setTelaBruta(nova) }

  const irParaLogin = () => {
    try { if (window.location.search) window.history.replaceState({}, '', window.location.pathname) } catch { /* sem history: nada a limpar */ }
    setErro(''); setDicaEmail(''); setNovaSenha(''); setConfirma(''); irPara('login', true); aoConcluir && aoConcluir()
  }

  // chegou pelo link do e-mail/WhatsApp: confere se ainda vale antes de pedir a senha nova
  useEffect(() => {
    if (!tokenUrl) return
    let vivo = true
    axios.post(`${API}/auth/redefinir-senha/validar`, { token: tokenUrl })
      .then((r) => { if (vivo) setLinkValido(!!r.data?.valido) })
      .catch((e) => { if (vivo) { setLinkValido(false); setErro(erroMsg(e, '')) } })
    return () => { vivo = false }
  }, [tokenUrl])

  const entrar = async (e: React.FormEvent) => {
    e.preventDefault(); setErro(''); setLoading(true)
    try { await login(email, senha) }
    catch (err: any) { setErro(erroMsg(err, 'Erro ao fazer login')) }
    finally { setLoading(false) }
  }

  const pedirLink = async (e: React.FormEvent) => {
    e.preventDefault(); setErro('')
    if (!EMAIL_RX.test(email.trim())) { setErro('Informe o e-mail do seu cadastro'); return }
    setLoading(true)
    try {
      const r = await axios.post(`${API}/auth/esqueci-senha`, { email: email.trim(), canal })
      setMensagem(r.data?.mensagem || 'Se o e-mail estiver cadastrado, enviamos o link para criar uma nova senha.'); irPara('enviado')
    } catch (err: any) { setErro(erroMsg(err, 'Não foi possível enviar agora. Tente de novo.')) }
    finally { setLoading(false) }
  }

  const salvarSenha = async (e: React.FormEvent) => {
    e.preventDefault(); setErro('')
    const problema = erroDaSenha(novaSenha)
    if (problema) { setErro(problema); return }
    if (novaSenha !== confirma) { setErro('As senhas não conferem'); return }
    setLoading(true)
    try { await axios.post(`${API}/auth/redefinir-senha`, { token: tokenUrl, nova_senha: novaSenha }); setNovaSenha(''); setConfirma(''); irPara('redefinido') }
    catch (err: any) { setErro(erroMsg(err, 'Não foi possível trocar a senha. Tente de novo.')) }
    finally { setLoading(false) }
  }

  const titulo = (t: string, sub?: string) => (
    <div style={{ marginBottom: '.2rem' }}>
      <h2 className="lg-titulo">{t}</h2>
      {sub && <p className="lg-sub">{sub}</p>}
    </div>
  )
  const caixaErro = erro ? <div className="lg-erro" role="alert">{erro}</div> : null
  // retorno na hora: o formato do e-mail e conferido ao sair do campo, nao so ao enviar
  const campoEmail = (id: string, valor: string, aoMudar: (v: string) => void) => (
    <div>
      <label className="lg-rotulo" htmlFor={id}>E-mail</label>
      <input id={id} className="lg-campo" type="email" placeholder="seu@email.com.br" autoComplete="username" value={valor} required aria-invalid={!!dicaEmail}
        onChange={(e) => { aoMudar(e.target.value); if (dicaEmail) setDicaEmail('') }}
        onBlur={() => setDicaEmail(valor.trim() && !EMAIL_RX.test(valor.trim()) ? 'Esse e-mail não parece completo' : '')} />
      {dicaEmail && <p className="lg-dica" aria-live="polite">{dicaEmail}</p>}
    </div>
  )

  return (
    <div className={`lg-raiz${escuro ? ' dark' : ''}`}>
      <style>{CSS}</style>
      <aside className="lg-marca" aria-hidden="true">
        <h1 className="lg-display">Sua frota sob controle, em tempo real.</h1>
        <div className="lg-benef">
          <span><i>📍</i>Mapa ao vivo e replay de trajetos</span>
          <span><i>🔔</i>Alertas de condução, cercas e manutenção</span>
          <span><i>📊</i>Relatórios e fechamento de viagens</span>
        </div>
      </aside>

      <main className="lg-form">
        <div className="lg-cartao">
          <img className="lg-logo" src={`${process.env.PUBLIC_URL}/logo-moobifleet.png`} alt="MoobiFleet" />

          {tela === 'login' && (
            <form key="login" className={`lg-vista${volta ? ' volta' : ''}`} onSubmit={entrar}>
              {titulo('Bem-vindo de volta', 'Entre com seu e-mail e senha')}
              {campoEmail('lg-email', email, setEmail)}
              <CampoSenha id="lg-senha" rotulo="Senha" valor={senha} aoMudar={setSenha} autoComplete="current-password" />
              <div style={{ textAlign: 'right', marginTop: '-.35rem' }}>
                <button type="button" className="lg-link" onClick={() => { setErro(''); irPara('esqueci') }}>Esqueci minha senha</button>
              </div>
              {caixaErro}
              <button className="lg-botao" type="submit" disabled={loading}>{loading ? 'Entrando...' : 'Entrar'}</button>
            </form>
          )}

          {tela === 'esqueci' && (
            <form key="esqueci" className={`lg-vista${volta ? ' volta' : ''}`} onSubmit={pedirLink}>
              {titulo('Esqueci minha senha', 'Informe o e-mail do seu cadastro e escolha onde receber o link para criar uma nova senha.')}
              {campoEmail('lg-email2', email, setEmail)}
              <fieldset style={{ border: 'none', margin: 0, padding: 0 }}>
                <legend className="lg-rotulo">Receber o link por</legend>
                <label style={{ display: 'flex', gap: '.5rem', alignItems: 'center', fontSize: '.9375rem', marginBottom: '.4rem', cursor: 'pointer' }}>
                  <input type="radio" name="canal" checked={canal === 'email'} onChange={() => setCanal('email')} /> E-mail
                </label>
                <label style={{ display: 'flex', gap: '.5rem', alignItems: 'center', fontSize: '.9375rem', cursor: 'pointer' }}>
                  <input type="radio" name="canal" checked={canal === 'whatsapp'} onChange={() => setCanal('whatsapp')} /> WhatsApp
                </label>
                {canal === 'whatsapp' && <div className="lg-sub" style={{ fontSize: '.75rem', marginTop: '.4rem' }}>Só funciona se o seu cadastro tem um celular. Sem celular cadastrado, enviamos por e-mail.</div>}
              </fieldset>
              {caixaErro}
              <button className="lg-botao" type="submit" disabled={loading}>{loading ? 'Enviando...' : 'Enviar link'}</button>
              <div style={{ textAlign: 'center' }}><button type="button" className="lg-link" onClick={irParaLogin}>Voltar ao login</button></div>
            </form>
          )}

          {tela === 'enviado' && (
            <div key="enviado" className={`lg-vista${volta ? ' volta' : ''}`}>
              {titulo('Confira sua caixa de entrada')}
              <div className="lg-ok" role="status">{mensagem}</div>
              <div className="lg-sub" style={{ fontSize: '.75rem' }}>Não chegou? Veja o spam ou peça um novo link. Motoristas que entram só pelo aplicativo devem pedir a nova senha ao gestor.</div>
              <button className="lg-botao" type="button" onClick={irParaLogin}>Voltar ao login</button>
            </div>
          )}

          {tela === 'redefinir' && (
            linkValido === null ? <div className="lg-sub" style={{ textAlign: 'center' }}>Conferindo o link...</div>
            : linkValido === false ? (
              <div key="invalido" className="lg-vista">
                {titulo('Link inválido ou expirado')}
                {caixaErro}
                <div className="lg-sub">O link vale por 30 minutos e só pode ser usado uma vez. Peça um novo link para criar a sua senha.</div>
                <button className="lg-botao" type="button" onClick={() => { try { window.history.replaceState({}, '', window.location.pathname) } catch { /* ok */ } setErro(''); irPara('esqueci') }}>Pedir novo link</button>
                <div style={{ textAlign: 'center' }}><button type="button" className="lg-link" onClick={irParaLogin}>Voltar ao login</button></div>
              </div>
            ) : (
              <form key="redefinir" className="lg-vista" onSubmit={salvarSenha}>
                {titulo('Criar nova senha', 'Mínimo de 8 caracteres, com letras e números.')}
                <CampoSenha id="lg-nova" rotulo="Nova senha" valor={novaSenha} aoMudar={setNovaSenha} autoComplete="new-password" />
                <Regras senha={novaSenha} />
                <CampoSenha id="lg-conf" rotulo="Repita a nova senha" valor={confirma} aoMudar={setConfirma} autoComplete="new-password" />
                {caixaErro}
                <button className="lg-botao" type="submit" disabled={loading}>{loading ? 'Salvando...' : 'Salvar nova senha'}</button>
              </form>
            )
          )}

          {tela === 'redefinido' && (
            <div key="redefinido" className="lg-vista">
              {titulo('Senha alterada')}
              <div className="lg-ok" role="status">Pronto! Sua senha foi alterada. Entre com a nova senha.</div>
              <button className="lg-botao" type="button" onClick={irParaLogin}>Ir para o login</button>
            </div>
          )}

          <p className="lg-rodape">MoobiFleet © {new Date().getFullYear()} — Todos os direitos reservados</p>
        </div>
      </main>
    </div>
  )
}
